var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotobookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6665 5.33333H7.99984V22.6667H27.9998V6.66667C27.9998 5.93029 27.4029 5.33333 26.6665 5.33333ZM29.3332 22.6667V6.66667C29.3332 5.19391 28.1393 4 26.6665 4H7.99984H6.6665H5.33317C3.86041 4 2.6665 5.19391 2.6665 6.66667V25.3333C2.6665 26.8061 3.86041 28 5.33317 28H26.6665C28.1393 28 29.3332 26.8061 29.3332 25.3333V22.6667ZM3.99984 23.0234V6.66667C3.99984 5.93029 4.59679 5.33333 5.33317 5.33333H6.6665V22.6667H5.33317C4.84745 22.6667 4.39207 22.7965 3.99984 23.0234ZM27.9998 24H7.99984H6.6665H5.33317C4.59679 24 3.99984 24.597 3.99984 25.3333C3.99984 26.0697 4.59679 26.6667 5.33317 26.6667H26.6665C27.4029 26.6667 27.9998 26.0697 27.9998 25.3333V24ZM23.9998 18.1488L20.4443 13.2121L17.185 17.4545L14.7406 14.9091L11.9998 18.3339V9.33333H23.9998V18.1488ZM15.5554 11.9394C15.5554 11.2365 15.0082 10.6667 14.3332 10.6667C13.6582 10.6667 13.1109 11.2365 13.1109 11.9394C13.1109 12.6423 13.6582 13.2121 14.3332 13.2121C15.0082 13.2121 15.5554 12.6423 15.5554 11.9394ZM10.6665 8V20H25.3332V8H10.6665Z",
    fill: "#4A4A4A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotobookIcon);
export default __webpack_public_path__ + "static/media/photobook-icon.e81e5a19fa27a28b96e5a1d6ac0aad84.svg";
export { ForwardRef as ReactComponent };